export default __webpack_public_path__ + "static/media/web-dev.eff65712.jpg";